(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  const initializePawviaTransparentHeaderHome = (root = document) => {
    const selector = '[data-pawvia-transparent-header-home="true"]';
    const shells = [];

    if (root instanceof Element && root.matches(selector)) {
      shells.push(root);
    }

    if (root.querySelectorAll) {
      shells.push(...root.querySelectorAll(selector));
    }

    shells.forEach((shell) => {
      if (shell.dataset.pawviaTransparentHeaderInitialized === 'true') return;

      const section = shell.closest('.section-header');
      if (!section) return;

      shell.dataset.pawviaTransparentHeaderInitialized = 'true';

      const headerGroup = section.closest('.shopify-section-group-header-group, [id*="shopify-section-group-header"]');

      const setHeaderHeight = () => {
        const height = Math.max(0, Math.round(shell.getBoundingClientRect().height));
        if (height > 0) {
          section.style.setProperty('--pawvia-transparent-header-height', `${height}px`);
        }
      };

      const hasOpenHeaderInteraction = () => {
        const openDisclosure = shell.querySelector(
          'header-menu details[open], header-drawer details[open], details-modal details[open], localization-form details[open]'
        );
        const openLocalization = shell.querySelector(
          'localization-form .localization-form__select[aria-expanded="true"], localization-form .disclosure__button[aria-expanded="true"]'
        );
        const activeCartNotification = section.querySelector(
          'cart-notification.active, #cart-notification.active, cart-notification .cart-notification.active'
        );

        return Boolean(openDisclosure || openLocalization || activeCartNotification);
      };

      const updateHeaderState = () => {
        const shouldBeOpaque =
          section.classList.contains('scrolled-past-header') || hasOpenHeaderInteraction();

        section.classList.toggle('pawvia-transparent-header-home--opaque', shouldBeOpaque);

        if (headerGroup) {
          headerGroup.classList.toggle('pawvia-transparent-header-group-home--opaque', shouldBeOpaque);
        }
      };

      const mutationObserver = new MutationObserver(() => {
        updateHeaderState();
      });

      mutationObserver.observe(section, {
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-expanded', 'hidden'],
        childList: true,
        subtree: true
      });

      let resizeObserver;

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(() => {
          setHeaderHeight();
        });
        resizeObserver.observe(shell);
      }

      const onResize = () => {
        setHeaderHeight();
      };

      window.addEventListener('resize', onResize);

      setHeaderHeight();
      updateHeaderState();

      section.pawviaTransparentHeaderCleanup = () => {
        mutationObserver.disconnect();

        if (resizeObserver) {
          resizeObserver.disconnect();
        }

        window.removeEventListener('resize', onResize);

        if (headerGroup) {
          headerGroup.classList.remove('pawvia-transparent-header-group-home--opaque');
        }
      };
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializePawviaTransparentHeaderHome(), { once: true });
  } else {
    initializePawviaTransparentHeaderHome();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializePawviaTransparentHeaderHome(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (typeof event.target.pawviaTransparentHeaderCleanup === 'function') {
      event.target.pawviaTransparentHeaderCleanup();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
